/* eslint-disable import/prefer-default-export */
export const GET_CUSTOMER_REVENUE_URL = `https://slot.tizeti.com/geniatechapi/index.php`;
